import React, { useState, useEffect, useRef, useCallback } from "react";
import { Carousel } from "react-responsive-carousel";
// import CustomAudioPlayer from "./CustomAudioPlayer";
import CustomVideoPlayer from "./CustomVideoPlayer";
import { AWS_URL } from "../config/constants";
import { X, Lock, ZoomIn, ZoomOut, Pause, Play } from "lucide-react";
import { Link } from "react-router-dom";
import { getUserProfilePic } from "../helper/GeneralHelper";
import { useTranslation } from "react-i18next";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const CustomFancybox = (props) => {
  const [autoPlay, setAutoPlay] = useState(false);
  const [current, setCurrent] = useState(0);
  const [isZoom, setIsZoom] = useState(false);
  const [isTouch, setIsTouch] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [prevTouchX, setPrevTouchX] = useState(0);
  const [prevTouchY, setPrevTouchY] = useState(0);
  const [prevTouch2X, setPrevTouch2X] = useState(0);
  const [prevTouch2Y, setPrevTouch2Y] = useState(0);
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);

  // Use refs for values that need to be accessed in callbacks without causing re-renders
  const stateRef = useRef({ isZoom, isTouch, zoom, prevTouchX, prevTouchY, prevTouch2X, prevTouch2Y, x, y, current, autoPlay });
  stateRef.current = { isZoom, isTouch, zoom, prevTouchX, prevTouchY, prevTouch2X, prevTouch2Y, x, y, current, autoPlay };

  const { t } = useTranslation();

  const controlAudio = useCallback((index) => {
    let newIndex = 0;
    if (props.place === "postMedias") {
      newIndex = props.medias
        .filter((media) => !media.type?.includes("audio"))
        .findIndex(
          (media) =>
            media._id + media?.name ===
            props.medias[index]._id + props.medias[index]?.name
        );
      return newIndex;
    } else {
      newIndex = props.medias
        .filter((media) => !media.type?.includes("audio"))
        .findIndex(
          (media) =>
            media.messageId + media?.name ===
            props.medias[index].messageId + props.medias[index]?.name
        );
      return newIndex;
    }
  }, [props.medias, props.place]);

  useEffect(() => {
    setCurrent(controlAudio(props.current));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMouseMove = (e) => {
    e.preventDefault();
    if (window.innerWidth > 512) {
      if (stateRef.current.isZoom) {
        const img = document.getElementById(
          props.index + "-" + stateRef.current.current + "-carousel"
        );
        const divElement = e.target;
        const rect = divElement.getBoundingClientRect();
        const xPos = e.clientX - rect.left;
        const yPos = e.clientY - rect.top;
        const divW = e.target.clientWidth;
        const divH = e.target.clientHeight;
        const tranX = ((xPos - divW / 2) / divW) * -100;
        const tranY = ((yPos - divH / 2) / divH) * -100;
        img.style.transform = `scale(2.5) translate(${tranX}%, ${tranY}%)`;
      }
    }
  };

  const handleTouchMove = (e) => {
    const st = stateRef.current;
    if (st.isTouch && st.isZoom) {
      if (e.touches.length > 1) {
        if (e.touches.length === 2) {
          const touch = e.touches[0];
          const touch2 = e.touches[1];
          const newZoom =
            st.zoom +
            (st.prevTouchX + st.prevTouch2X !==
            touch.clientX + touch2.clientX
              ? (st.prevTouchX +
                  st.prevTouch2X -
                  (touch.clientX + touch2.clientX)) /
                100
              : 0) +
            (st.prevTouchY + st.prevTouch2Y !==
            touch.clientY + touch2.clientY
              ? (st.prevTouchY +
                  st.prevTouch2Y -
                  (touch.clientY + touch2.clientY)) /
                100
              : 0);
          setPrevTouchX(touch.clientX);
          setPrevTouchY(touch.clientY);
          setPrevTouch2X(touch2.clientX);
          setPrevTouch2Y(touch2.clientY);
          setZoom(newZoom);
          // Apply transform directly using current values since setState is async
          const img = document.getElementById(
            props.index + "-" + st.current + "-carousel"
          );
          img.style.transform = `scale(${newZoom}) translate(${st.x}px, ${st.y}px)`;
        } else {
        }
      } else {
        const touch = e.touches[0];
        const newX = st.x + touch.clientX - st.prevTouchX;
        const newY = st.y + touch.clientY - st.prevTouchY;
        setX(newX);
        setY(newY);
        setPrevTouchX(touch.clientX);
        setPrevTouchY(touch.clientY);
        // Apply transform directly
        const img = document.getElementById(
          props.index + "-" + st.current + "-carousel"
        );
        img.style.transform = `scale(${st.zoom}) translate(${newX}px, ${newY}px)`;
      }
    }
  };

  const disableZoom = () => {
    setIsZoom(false);
    setZoom(1);
    const img = document.getElementById(
      props.index + "-" + stateRef.current.current + "-carousel"
    );
    img.zoom = 1;
    img.style.transform = `scale(1) translate(${0}px, ${0}px)`;
  };

  const activeZoom = () => {
    if (
      props.medias
        .filter((media) => !media.type?.includes("audio"))
        [stateRef.current.current]?.type?.includes("image")
    ) {
      setIsZoom(true);
      setZoom(2.5);
      const img = document.getElementById(
        props.index + "-" + stateRef.current.current + "-carousel"
      );
      img.zoom = 2.5;
      img.style.transform = `scale(2.5) translate(${0}px, ${0}px)`;
    }
  };

  const manageAutoPlay = () => {
    let medias = props.medias.filter(
      (media) => !media.type?.includes("audio")
    );
    let timer = 5000;
    setTimeout(() => {
      const st = stateRef.current;
      const newCurrent = (st.current ? st.current : 0) + 1;
      setCurrent(newCurrent);
      if (st.autoPlay && medias.length > newCurrent + 1) {
        manageAutoPlay();
      } else {
        setAutoPlay(false);
      }
    }, timer);
  };

  const width = window.innerWidth;
  const isMobile = width <= 512;
  return (
    <div
      id={props.id ? props.id : "general-fancybox"}
      className={`fancybox-container ${
        props.show ? "" : "display-none"
      } ${
        props.medias[0]?.isVR ||
        props.medias[0]?.projectionType !== 0
          ? "disable-transform-carousel"
          : ""
      }`}
      style={{
        animationDelay: "10s",
        touchAction: "none",
        userSelect: "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "0px",
          left: "0px",
          paddingTop: "8px",
          paddingLeft: "16px",
          zIndex: "99999",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: "white",
          fontSize: "24px",
        }}
      >
        {current + 1}
        {" / "}
        {
          props.medias.filter((media) => !media.type?.includes("audio"))
            .length
        }
      </div>
      <div
        style={{
          position: "absolute",
          top: "0px",
          right: "0px",
          paddingRight: "16px",
          paddingTop: "8px",
          paddingBottom: "16px",
          paddingLeft: "16px",
          zIndex: "99999",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        {isZoom ? (
          <div
            className="hover"
            onClick={() => {
              disableZoom();
            }}
          >
            <ZoomOut
              size={24}
              style={{ color: "white" }}
            />
          </div>
        ) : (
          <>
            {props.medias
              .filter((media) => !media.type?.includes("audio"))
              [current]?.type?.includes("image") && (
              <div
                className="hover"
                onClick={() => {
                  activeZoom();
                }}
              >
                <ZoomIn
                  size={24}
                  style={{ color: "white" }}
                />
              </div>
            )}
          </>
        )}
        <div
          style={{ width: "24px" }}
          className="hover"
          onClick={() => {
            const newAutoPlay = !autoPlay;
            setAutoPlay(newAutoPlay);
            if (newAutoPlay) {
              // Need to use setTimeout to let state update, then call manageAutoPlay
              setTimeout(() => manageAutoPlay(), 0);
            }
          }}
        >
          {autoPlay ? (
            <Pause size={18} style={{ color: "white" }} />
          ) : (
            <Play size={24} style={{ color: "white" }} />
          )}
        </div>
        <div
          className="hover"
          onClick={() => {
            props.hide();
          }}
        >
          <X size={24} style={{ color: "white" }} />
        </div>
      </div>
      <Carousel
        verticalSwipe={"natural"}
        showStatus={true}
        emulateTouch={true}
        onChange={(e) => {
          const img = document.getElementById(
            props.index + "-" + current + "-carousel"
          );
          if (img) {
            img.style.transform = `scale(1) translate(${0}px, ${0}px)`;
          }

          setCurrent(e);
          setIsZoom(false);
        }}
        selectedItem={
          current && autoPlay
            ? current
            : controlAudio(props.current)
        }
        showThumbs={true}
        width="100%"
        dynamicHeight={false}
        renderThumbs={() =>
          props.medias
            .filter((media) => !media.type?.includes("audio"))
            .map((thumbnail) => (
              <img
                style={{ height: "88px", width: "88px", objectFit: "cover" }}
                src={
                  thumbnail.locked
                    ? thumbnail?.blurredThumbNailUrl
                    : (thumbnail.type?.includes("audio")
                        ? AWS_URL + "logo/audio.png"
                        : "") +
                      (thumbnail.type?.includes("image")
                        ? thumbnail.url
                        : "") +
                      (thumbnail.type?.includes("video")
                        ? thumbnail.thumbNailUrl
                        : "")
                }
                alt=""
              ></img>
            ))
        }
        showIndicators={false}
        swipeable={isZoom === true ? false : true}
        centerMode={false}
        showArrows={true}
        className={props.medias?.length <= 1 ? "hideDots" : ""}
      >
        {props.medias?.length > 0
          ? props.medias
              .filter((media) => !media.type?.includes("audio"))
              .map((media, indexMedia) => (
                <div
                  style={{
                    width: "100%",
                    height: "calc(100dvh - 128px)",
                    display: "grid",
                    alignItems: "center",
                    justifyItems: "center",
                  }}
                  key={indexMedia}
                >
                  <div
                    style={{
                      touchAction: "manipulation",
                      maxHeight: "70dvh",
                      height: "100%",
                      width: "calc(100% - 96px)",
                      maxWidth: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      position: "relative",
                      overflow: "hidden",
                      background:
                        media.locked && media?.blurredThumbNailUrl
                          ? `url(${media?.blurredThumbNailUrl})`
                          : "transparent",
                      backgroundSize: "cover",
                    }}
                    onDoubleClick={() => {
                      if (media.type?.includes("image")) {
                        const newIsZoom = !isZoom;
                        const newZoom = isZoom === false ? 2.5 : 1;
                        setZoom(newZoom);
                        setIsZoom(newIsZoom);
                        const img = document.getElementById(
                          props.index +
                            "-" +
                            current +
                            "-carousel"
                        );
                        img.zoom = 2.5;
                        img.style.transform = `scale(2.5) translate(${0}px, ${0}px)`;
                      }
                    }}
                    onMouseMove={(e) => {
                      if (media.type?.includes("image")) {
                        handleMouseMove(e);
                      }
                    }}
                    onTouchMove={(e) => {
                      if (media.type?.includes("image")) {
                        e.preventDefault();
                        handleTouchMove(e);
                      }
                    }}
                    onTouchStart={(e) => {
                      if (media.type?.includes("image")) {
                        setPrevTouchX(e?.touches[0]?.clientX);
                        setPrevTouchY(e?.touches[0]?.clientY);
                        setPrevTouch2X(e?.touches[1]?.clientX);
                        setPrevTouch2Y(e?.touches[1]?.clientY);
                        setIsTouch(true);
                      }
                    }}
                    onTouchEnd={(e) => {
                      if (media.type?.includes("image")) {
                        if (e.touches.length < 1) {
                          setIsTouch(false);
                        }
                      }
                    }}
                    // onWheel={handleWheel}
                  >
                    {media.type?.includes("image") && !media.locked && (
                      <img
                        style={{
                          maxHeight: "70dvh",
                          width: "100%",
                          maxWidth: "100%",
                          transform: `scale(1) translate(0px, 0px)`,
                          transition: "none",
                          touchAction: "none",
                        }}
                        className="width-image-common-post"
                        alt=""
                        id={props.index + "-" + indexMedia + "-carousel"}
                        src={media.url}
                      />
                    )}
                    {media.type?.includes("video") && !media.locked && (
                      <CustomVideoPlayer
                        thumbNailUrl={media.thumbNailUrl}
                        url={media.url}
                        id={props.index + "-" + indexMedia}
                        isFancyBox={true}
                        media={media}
                      />
                    )}
                    {media.locked && (
                      <>
                        <div
                          style={{
                            filter: "blur(20px)",
                            width: "100%",
                            zIndex: 1,
                            position: "relative",
                          }}
                        ></div>
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            position: "absolute",
                            top: "0px",
                            left: "0px",
                            zIndex: "2",
                          }}
                        >
                          <div
                            style={{
                              height: "100%",
                              width: "100%",
                              display: "grid",
                              alignItems: "center",
                              justifyItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "grid",
                                justifyItems: "center",
                                height: "fit-content",
                                width: isMobile ? "90%" : "50%",
                              }}
                            >
                              <div
                                style={{
                                  justifyContent: "center",
                                  gap: "8px",
                                  display: "grid",
                                  justifyItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    justifyContent: "center",
                                  }}
                                  className="chat-lock-box-fancy"
                                >
                                  <Lock size={20} />
                                </div>
                                <span className="locked-content-text">
                                  {t("clip.lockedContent")}
                                </span>
                              </div>
                              <div style={{ width: "90%" }}>
                                {props.place === "postMedias" ? (
                                  <Link
                                    to={{
                                      pathname: "/payment",
                                      state: {
                                        creatorDetails: media.userDetails,
                                        postDetails: media,
                                        creatorPicture: getUserProfilePic(
                                          media.userDetails?._id,
                                          media.userDetails?.profilePicture,
                                          true,
                                          "0% 0% / cover no-repeat"
                                        ),
                                        price: media.price,
                                        typeOfPayment: 3,
                                        postId: media._id,
                                      },
                                    }}
                                  >
                                    <button className="width-button-buy-clip p-0 btn p-2 lh-24 w125 d-inline-block rounded-xl chatButtonPurchase border-red detailTitle fw-700 text-white">
                                      {t("chat.unlockMediaFor", {
                                        numberOfMedia: media.numberOfMedias,
                                        price: media?.price,
                                      })}
                                    </button>
                                  </Link>
                                ) : (
                                  <button
                                    onClick={() => {
                                      props.customPayment(indexMedia);
                                    }}
                                    className="width-button-buy-clip p-0 btn p-2 lh-24 w125 d-inline-block rounded-xl chatButtonPurchase border-red detailTitle fw-700 text-white"
                                  >
                                    {t("chat.unlockMediaFor", {
                                      numberOfMedia: media.numberOfMedias,
                                      price: media?.messagePrice,
                                    })}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* {media.type?.includes("audio")&& !media.locked && (
                    <CustomAudioPlayer src={media.url} />
                  )} */}
                  </div>
                </div>
              ))
          : null}
      </Carousel>
    </div>
  );
};

export default CustomFancybox;
